import { ArrayBase } from '../ArrayBase';

export class CustomXandrSegments extends ArrayBase {}
